import { FC, ReactElement } from "react";

const Save:FC =():ReactElement=>{
    return(
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path d="M0 2c0-1.1 0.9-2 2-2h14l4 4v14c0 1.105-0.895 2-2 2v0h-16c-1.105 0-2-0.895-2-2v0-16zM5 2v6h10v-6h-10zM11 3h3v4h-3v-4z"></path>
        </svg>
    )
}

export default Save;